import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { SessionService } from '@app/shared/services/session.service';
import { TitleService } from '@app/shared/services/title.service';

@Component({
  selector: 'app-company-informations',
  templateUrl: './company-informations.component.html',
  styleUrls: ['./company-informations.component.scss']
})
export class CompanyInformationsComponent implements OnInit {

  public company : any = {
    Name: "Créa'tiff Coiffure",
    Mobile: "06 45 78 98 11"
  };
  public members : any = [{
    FirstName: "John",
    LastName: "Doe"
  }];
  public loading: boolean = false;
  public formChanged: boolean = true;
  public noMemberResult: boolean = false;
  public loadingMember: boolean = false;

  public sirenMissing: boolean = false;
  public kbisMissing: boolean = false;

  public creditCard: string = `**** **** **** 1234`;

  constructor(
    public session: SessionService,
    private menu: MenuService,
    private titleService: TitleService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(`Information sur l'entreprise / VOP`);
    this.menu.setMenuType('company');
    this.menu.setMenuState('company', '', '');
    this.session.view.company = 1; // set in the view menu instead
  }

  updateCompany() {

  }

  addSocietyMember(member) {

  }

  deleteCompanyMember(member) {

  }

  getKBIS() {

  }

  getSIREN() {

  }
}
